import Vue from 'vue';
import BoldReportViewer from "./reports/BoldReportViewer"
import Footer from "./Footer"
import Header from "./Header"
import SrsCodesTable from "./tables/SrsCodesTable"
import UsersTable from "./tables/UsersTable"
import SearchBar from "./SearchBar";
import SuppliersTable from "./tables/SuppliersTable"
import SupplierTab from "../views/MainContainer/Users/tabs/SupplierTab"
import CorpUser from "../views/MainContainer/CorpUsers/CorpUser"
import CorpUserForm from "../views/MainContainer/CorpUsers/CorpUserForm"
import CorpUserOverview from "../views/MainContainer/CorpUsers/CorpUserOverview"
import CorpUserTable from "./tables/CorpUsersTable"
import QueuedCodesTable from "./tables/QueuedCodesTable"
import BaseTable from "./tables/BaseTable"

Vue.component("BoldReportViewer", BoldReportViewer);
Vue.component("Footer", Footer);
Vue.component("Header", Header);
Vue.component("SrsCodesTable", SrsCodesTable);
Vue.component("UsersTable", UsersTable);
Vue.component("SearchBar", SearchBar);
Vue.component("SuppliersTable", SuppliersTable);
Vue.component("SupplierTab", SupplierTab);
Vue.component("CorpUser", CorpUser);
Vue.component("CorpUserTable", CorpUserTable);
Vue.component("CorpUserForm", CorpUserForm);
Vue.component("CorpUserOverview", CorpUserOverview);
// Vue.component("QueuedCodes", QueuedCodes);
Vue.component("QueuedCodesTable", QueuedCodesTable);
Vue.component("BaseTable", BaseTable);

import SupplierSelect from './SupplierSelect.vue'
Vue.component('SupplierSelect', SupplierSelect)

import SupplierSelectDialog from './SupplierSelectDialog.vue'
Vue.component('SupplierSelectDialog', SupplierSelectDialog)

import Dialog from './Dialog.vue'
Vue.component('Dialog', Dialog)

import Table from './tables/Table/Table.vue'
Vue.component('Table', Table)

import RequestTable from './tables/RequestTable/RequestTable.vue'
Vue.component('RequestTable', RequestTable)

import SrsCodeChangeDialog from './dialogs/SrsCodeChangeDialog.vue'
Vue.component('SrsCodeChangeDialog', SrsCodeChangeDialog)

import PageHeader from './PageHeader/PageHeader.vue'
Vue.component('PageHeader', PageHeader)

import PageContainer from './PageContainer.vue'
Vue.component('PageContainer', PageContainer)

import SrsCodeChangeLogsDrawer from './SrsCodeChangeLogsDrawer.vue'
Vue.component('SrsCodeChangeLogsDrawer', SrsCodeChangeLogsDrawer)

import TopBar from './TopBar.vue'
Vue.component('TopBar', TopBar)

import SideNav from './SideNav.vue'
Vue.component('SideNav', SideNav)